"use strict";var e=require("styled-components");require("react");var o=require("prop-types"),r=require("@vds-core/utilities"),n=require("@vds-tokens/color"),t=require("@vds-tokens/typography"),a=require("@vds-tokens/form-controls"),l=require("@vds-core/typography");function i(e){return e&&e.__esModule?e:{default:e}}var d=i(e),c=i(o);const s={checked:c.default.bool,disabled:c.default.bool,transparentBackground:c.default.bool,borderColor:c.default.string},u=e=>"string"==typeof e?e:r.calculateRem(e),b=e=>"string"==typeof e?"12px"===e?l.Fonts.VerizonNHGeTX:l.Fonts.VerizonNHGeDS:12===e?l.Fonts.VerizonNHGeTX:l.Fonts.VerizonNHGeDS,h=d.default.div.withConfig({displayName:"RadioBoxLabelWrapper",componentId:"VDS__sc-6gb90f-0"})`
  align-items: center;
  border-radius: ${({borderRadius:e})=>e};
  border: ${({borderColor:e,surface:o})=>`1px solid ${"dark"===o?a.FormControlsTokens.color.border.ondark.value:e}`};
  display: block;
  flex: ${e=>"vertical"===e.orientation?"1 1 auto":e.width?`0 0 ${u(e.width)}`:"1"};
  font-size: ${({fontSize:e})=>r.calculateRem(e)};
  letter-spacing: ${({letterSpacing:e})=>r.calculateRem(e)};
  line-height: ${({lineHeight:e})=>r.calculateRem(e)};
  font-family: ${({fontSize:e})=>b(e)};
  height: 100%;
  min-height: ${({height:e})=>e||r.calculateRem(44)};
  position: relative;
  width: ${e=>e.width?u(e.width):"100%"};
  max-width: 100%;
  box-sizing: border-box;
  background-color: ${({surface:e,transparentBackground:o})=>o?"transparent":"dark"===e?a.FormControlsTokens.color.background.ondark.value:a.FormControlsTokens.color.background.onlight.value};
  color: ${({disabled:e,surface:o})=>e?"dark"===o?n.ColorTokens.interactive.disabled.ondark.value:n.ColorTokens.interactive.disabled.onlight.value:"dark"===o?n.ColorTokens.elements.primary.ondark.value:n.ColorTokens.elements.primary.onlight.value};
  ${({disabled:e,checked:o,orientation:n,borderActiveIndicator:t,borderColorSelected:a})=>"highlight"===t&&!e&&"horizontal"===n&&`\n    &::before {\n      background:  ${o?a:"none"};\n      box-shadow: 'none';\n      content: '';\n      height: ${r.calculateRem(4)};\n      left: -1px;\n      right: -1px;\n      position: absolute;\n      top: -1px;\n      z-index: 1;\n    }\n  `};

  ${({disabled:e,checked:o,orientation:n,borderActiveIndicator:t,borderColorSelected:a})=>"highlight"===t&&!e&&"vertical"===n&&`\n    &::before {\n      background:  ${o?a:"none"};\n      box-shadow: 'none';\n      content: '';\n      width: ${r.calculateRem(4)};\n      left: -1px;\n      position: absolute;\n      top: -1px;\n      bottom: -1px;\n      z-index: 1;\n    }\n  `};
  ${({disabled:e,surface:o})=>e&&`\n    border-color: ${"dark"===o?n.ColorTokens.interactive.disabled.ondark.value:n.ColorTokens.interactive.disabled.onlight.value}`};

  ${({disabled:e,checked:o,borderActiveIndicator:t,borderColorActive:l,surface:i})=>!e&&o&&"outline"===t&&`\n       border: 1px solid ${"dark"===i?n.ColorTokens.elements.primary.ondark.value:l};\n       box-shadow: 0 0 0 \n        ${r.calculateRem(a.FormControlsTokens.border.width.value)}\n        ${"dark"===i?n.ColorTokens.elements.primary.ondark.value:l};;\n     `};
  ${({disabled:e,checked:o,borderActiveIndicator:r,borderColorActive:n})=>!e&&o&&"highlight"===r&&`\n       border-color: ${n};\n\n     `};

  ${({disabled:e,checked:o,active:t,surface:l,borderColorActive:i})=>!e&&!o&&t&&`\n       border: 1px solid ${"dark"===l?n.ColorTokens.elements.primary.ondark.value:i};\n       box-shadow: 0 0 0 \n        ${r.calculateRem(a.FormControlsTokens.border.width.value)}\n        ${"dark"===l?n.ColorTokens.elements.primary.ondark.value:i};;\n     `};

  ${({disabled:e,checked:o,active:n,hovered:t,borderColor:l,surface:i})=>!e&&!o&&!n&&t&&`\n     &:hover {\n       border: 1px solid ${"dark"===i?a.FormControlsTokens.color.border.ondark.value:l};\n       box-shadow: 0 0 0 \n          ${r.calculateRem(a.FormControlsTokens.border.width.value)}\n          ${"dark"===i?a.FormControlsTokens.color.border.ondark.value:l};;\n     }\n     `};
  outline: 0;
`,p=d.default.label.withConfig({displayName:"LabelBase",componentId:"VDS__sc-6gb90f-1"})`
  cursor: ${({disabled:e})=>e?"normal":"pointer"};
  height: 100%;
  z-index: 1;

  &:active,
  &:hover {
    outline: 0;
  }
`,g=e.css`
  display: block;
  padding: ${r.calculateRem(a.FormControlsTokens.space.inset.value)};

  .LabelContent {
    display: block;
  }
`,k=d.default(p).withConfig({displayName:"RadioBoxLabel",componentId:"VDS__sc-6gb90f-2"})`
  ${g};
  font-weight: ${({fontWeight:e})=>e};
  font-size: ${({fontSize:e})=>r.calculateRem(e)};
  letter-spacing: ${({letterSpacing:e})=>r.calculateRem(e)};
  line-height: ${({lineHeight:e})=>r.calculateRem(e)};
  font-family: ${({fontSize:e})=>b(e)};
`,m=d.default(p).withConfig({displayName:"StackedLabel",componentId:"VDS__sc-6gb90f-3"})`
  ${g};
  flex-grow: 1;
  font-weight: ${t.TypographyTokens.fontweight.bold.value};
  font-size: ${({fontSize:e})=>r.calculateRem(e)};
  letter-spacing: ${({letterSpacing:e})=>r.calculateRem(e)};
  line-height: ${({lineHeight:e})=>r.calculateRem(e)};
  font-family: ${({fontSize:e})=>b(e)};

  > * {
    &:not(:last-child) {
      margin-bottom: ${r.calculateRem(2)};
    }
  }
`,f=d.default.span.withConfig({displayName:"SubLabel",componentId:"VDS__sc-6gb90f-4"})`
  display: block;
  font-size: ${({fontSize:e})=>r.calculateRem(e)};
  letter-spacing: ${({letterSpacing:e})=>r.calculateRem(e)};
  line-height: ${({lineHeight:e})=>r.calculateRem(e)};
  font-family: ${({fontSize:e})=>b(e)};
  font-weight: ${t.TypographyTokens.fontweight.regular.value};
  margin: 0;
  pointer-events: none;
`;h.propTypes=s,h.defaultProps={checked:!1,transparentBackground:!1,disabled:!1},exports.RadioBoxLabel=k,exports.RadioBoxLabelWrapper=h,exports.StackedLabel=m,exports.SubLabel=f;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/radio-boxes/cjs/components/RadioBoxElements.js
// module id = 1149
// module chunks = 0